import { Box, Button } from "@mui/material";
import { homeBoxImgStyle } from "../../styles/home/home.styles";

type Props = {
  imageUrl: string;
  title: string;
  onClick?: () => void;
  href?: string; // <-- importante p/ SEO
};

export default function ActionSection({ imageUrl, title, onClick, href }: Props) {
  const isExternal = !!href && /^https?:\/\//.test(href);

  return (
    <Box sx={homeBoxImgStyle} component="section" aria-label={title}>
      <img
        src={imageUrl}
        alt={title}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
        loading="lazy"
        decoding="async"
      />

      <Button
        component={href ? "a" : "button"}
        href={href}
        onClick={onClick}
        // Segurança p/ link externo
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noopener noreferrer" : undefined}
        variant="outlined"
        sx={{
          borderRadius: 0,
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          position: "absolute",
          borderWidth: 5,
          color: "white",
          borderColor: "white",
          backgroundColor: "transparent",
          padding: "10px 20px",
          fontSize: "20px",
          fontWeight: "bold",
          mb: 4,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          "&:hover": {
            color: "black",
            backgroundColor: "white",
            borderColor: "#ffffff",
          },
        }}
        aria-label={title}
      >
        {title}
      </Button>
    </Box>
  );
}
